import { type UseQueryResult, useQuery } from 'react-query';
import { ParticipantInvestmentExperienceService } from '../../services/wealthlane-customer-services';

const useGetParticipantInvestmentExperience = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const ParticipantInvestmentExperienceList = useQuery(
    ['getParticipantInvestmentExperienceList'],
    async () => {
      return await handleRequest(
        ParticipantInvestmentExperienceService.getApiCustomerApiAppParticipantInvestmentExperienceParticipantInvestmentExperiencesList()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return ParticipantInvestmentExperienceList;
};

export default useGetParticipantInvestmentExperience;
